import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { FiGrid, FiFileText, FiBarChart2, FiUser, FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/candidate', icon: FiGrid, label: 'Dashboard', end: true },
  { to: '/candidate/exams', icon: FiFileText, label: 'My Exams' },
  { to: '/candidate/results', icon: FiBarChart2, label: 'Results' },
  { to: '/candidate/profile', icon: FiUser, label: 'Profile' },
];

export default function CandidateLayout() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => { await logout(); navigate('/login'); };

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Sidebar */}
      {open && <div className="fixed inset-0 bg-black/40 z-40 lg:hidden" onClick={() => setOpen(false)} />}
      <aside className={`fixed lg:static inset-y-0 left-0 z-50 w-60 bg-white border-r border-gray-100 flex flex-col transition-transform lg:translate-x-0 ${open ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="flex items-center gap-3 px-5 py-5 border-b">
          <div className="w-9 h-9 bg-navy rounded-xl flex items-center justify-center"><span className="text-white font-black">A</span></div>
          <div><div className="font-black text-gray-900">AssessHub</div><div className="text-xs text-gray-400">Candidate Portal</div></div>
        </div>
        <nav className="flex-1 p-3 space-y-0.5">
          {navItems.map(({ to, icon: Icon, label, end }) => (
            <NavLink key={to} to={to} end={end} onClick={() => setOpen(false)}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <Icon size={18} />{label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t">
          <div className="flex items-center gap-3 p-3 rounded-xl bg-gray-50 mb-2">
            <div className="w-9 h-9 bg-navy/10 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-navy font-bold text-sm">{user?.first_name?.[0]}{user?.last_name?.[0]}</span>
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold truncate">{user?.first_name} {user?.last_name}</div>
              <div className="text-xs text-gray-400 truncate">{user?.email}</div>
            </div>
          </div>
          <button onClick={handleLogout} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg font-medium">
            <FiLogOut size={15} /> Sign out
          </button>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <header className="bg-white border-b px-4 py-3 flex items-center gap-4 lg:hidden">
          <button onClick={() => setOpen(true)} className="p-2 rounded-lg hover:bg-gray-100"><FiMenu size={20} /></button>
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-navy rounded-lg flex items-center justify-center"><span className="text-white font-black text-xs">A</span></div>
            <span className="font-bold text-navy">AssessHub</span>
          </div>
        </header>
        <main className="flex-1 overflow-y-auto">
          <div className="p-4 lg:p-6 max-w-5xl mx-auto"><Outlet /></div>
        </main>
      </div>
    </div>
  );
}
